/**
 * Slider observer.
 *
 * @author Felix Kiesewetter <info@felixkiesewetter.de>
 * @lastModified 2026-06-11
 * @package fk_js/slider
 * @since 1.13.0
 * @version 1.0.0
 */
class Observer
{
    static init(sliderObject = null)
    {
        if (undefined === window._observer) {
            window._observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        sliderObject
                            .setState('visible', true)
                            .resumeAutoplay();
                        // TODO: Also check if this slider is more visible than other ones, see commented code below
                        return;
                    }
                    sliderObject
                        .setState('visible', false)
                        .holdAutoplay();
                });
            });
        }
        if (sliderObject) {
            Observer.observe(sliderObject);
        }

        /*
        if ('undefined' === typeof window._sliderIntersectionObserver) {
            window._sliderInstances = []
            const options = {
                rootMargin: '0px',
                threshold: 1
            }
            window._sliderIntersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {

                    const _this = entry.target?.parentNode?._sliderInstance
                    if (!_this) {
                        return
                    }

                    _this.isOnlySlider = 1 === window._sliderInstances.length

                    // This slider just became invisible:
                    if (_this.isVisible && !entry.isIntersecting) {
                        _this.isVisible = false
                        _this.#settings.debug && console.log('[Slider]', 'IntersectionObserver', 'Slider just became invisible')
                        _this.toggleAutoplay(false, 'intersection observer')
                        _this.stopVideos()
                    }

                    // This slider just became visible:
                    else if (!_this.isVisible && entry.isIntersecting) {
                        _this.isVisible = true
                        _this.#settings.debug && console.log('[Slider]', 'IntersectionObserver', 'Slider just became invisible')
                        _this.toggleAutoplay(true, 'intersection observer')
                        _this.#resize()
                    }

                    _this.#settings.debug && console.log('[Slider]', 'IntersectionObserver', {
                        isOnlySlider: _this.isOnlySlider,
                        isVisible: _this.isVisible
                    });
                });
            }, options);
        }
        */
        //window._sliderInstances.push(this);
        //window._sliderIntersectionObserver.observe(this.#intersectionObserverHelper);
    }

    static observe(sliderObject)
    {
        window._observer.observe(sliderObject.getNode());
        sliderObject.setState('observed', true);
    }

    static unobserve(sliderObject)
    {
        window._observer.unobserve(sliderObject.getNode());
        sliderObject.setState('observed', false);
    }

}

export default Observer;